import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import DetailHero from './components/DetailHero';
import ArticleContent from './components/ArticleContent';
import RelatedArticles from './components/RelatedArticles';
import CommentSection from './components/CommentSection';

export default function Detail() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <DetailHero />
        <ArticleContent />
        <CommentSection />
        <RelatedArticles />
      </main>
      <Footer />
    </div>
  );
}